import { POLICY_BUILDER_AGENT_URL, POLICY_BUILDER_AGENT_URL_ENTER, POLICY_BUILDER_DOWNLOAD_URL, POLICY_BUILDER_JWT_SECRET, getOrCreateConversationId, clearConversationId } from './_config.js';
import { marked } from 'marked';

marked.setOptions({
    gfm: true,
    breaks: true,
    smartLists: true,
    smartypants: true
});

const chatMessages = document.getElementById('chat-messages');

let triggerTracking = false;

function trackingEvent() {
    if (triggerTracking) return;
    
    try {
        if (!window.analytics) {
            console.warn('Analytics is not available');
            return;
        }

        const customUrlParams = new URLSearchParams(window.location.search);
        const trackingData = {
            utm_source: customUrlParams.get('utm_source') || '',
            utm_medium: customUrlParams.get('utm_medium') || '',
            utm_campaign: customUrlParams.get('utm_campaign') || '',
            utm_content: customUrlParams.get('utm_content') || '',
            url: window.location.href
        };

        window.analytics.track('ai_benefits_policy_builder_interaction', trackingData);
        triggerTracking = true;
        console.log('Tracking event triggered and blocked for future attempts');
    } catch (error) {
        console.error('Error sending tracking event:', error);
    }
}

export const removeHighlightRecentMsg = () => {
    document.querySelectorAll('.user-new-question').forEach(element => {
        element.classList.remove('user-new-question');
    });

}
export function toggleLoadingAnimation(show) {
    const loading = document.getElementById('loading');
    const chatMessengerInput = document.getElementById('chat-input-container');
    if(!show) {
        console.log('hide loader');
        chatMessengerInput.classList.remove('disabled');
        loading.classList.add('hidden');
    } else {
        console.log('show loader');
        chatMessengerInput.classList.add('disabled'); 
        loading.classList.remove('hidden');
    }
}

// Function to download file from fileId (global function)
window.downloadFile = async (fileId) => {
    try {
        console.log('Downloading file with ID:', fileId);
        
        const response = await fetch(POLICY_BUILDER_DOWNLOAD_URL, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${POLICY_BUILDER_JWT_SECRET}`,
                'Accept': 'application/json'
            },
            body: JSON.stringify({ 
                fileId: fileId 
            })
        });

        if (!response.ok) {
            throw new Error(`Failed to download file: ${response.status}`);
        }

        // Get the file content as blob (endpoint returns correct content-type)
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        
        // Create download link
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = 'doc_politica_beneficios_coverflex.docx';
        downloadLink.style.display = 'none';
        
        // Trigger download
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        
        // Clean up
        window.URL.revokeObjectURL(url);
        
        console.log('File downloaded successfully');
    } catch (error) {
        console.error('Error downloading file:', error);
        alert('Erro ao fazer download do ficheiro. Tenta novamente.');
    }
};

// Function to add message with download button
const addMessageWithDownload = (message, fileId) => {
    const messageElement = document.createElement('div');
    messageElement.classList.add('flex', 'flex-col', 'w-full');

    const formattedMessage = message.replace(/### (\d+)\. \*\*(.*?)\*\*/g, '<h3>$1. $2</h3>') 
                                    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')      
                                    .replace(/- (.*?)$/gm, '<li>$1</li>')                  
                                    .replace(/<\/li>\n<li>/g, '</li><li>')                  
                                    .replace(/<li>(.*?)<\/li>/g, '<ul><li>$1</li></ul>')   
                                    .replace(/<\/ul>\n<ul>/g, '')                         
                                    .replace(/<\/ul>\n<h3>/g, '</ul><br><h3>');           

    messageElement.innerHTML = `
    <div class="flex justify-start my-0 text-16 w-full flex-row gap-x-4">
        <svg class="flex flex-none" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="url(#a_bg_svg)"/><path d="M19.815 30.286a8.571 8.571 0 0 1 0-17.143v17.142Z" fill="#FDBD9A"/><path d="M21.243 10a7.142 7.142 0 1 1 0 14.286V10Z" fill="#F2F2F2"/><defs><linearGradient id="a_bg_svg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#FE7165"/><stop offset="1" stop-color="#FF8D78"/></linearGradient></defs></svg>
        <div class="bg-transparent text-black rounded-24 px-2 pb-4 text-16 text-darkblue leading-160 flex flex-col gap-y-2 w-full">
            ${formattedMessage}
            <button type="button" class="bg-download" onclick="downloadFile('${fileId}')">
                download política de benefícios
            </button>
        </div>
    </div>`;  

    removeHighlightRecentMsg();
    chatMessages.appendChild(messageElement);
    chatMessages.scrollTop = chatMessages.scrollHeight;
};

export const addMessageToChat = (message, sender = 'bot', el) => {
    const messageElement = document.createElement('div');
    messageElement.classList.add('flex', 'flex-col', 'w-full');

    if (sender === 'bot') {
        // Formatação do texto da mensagem

        // const formattedMessage = marked(message);

        const formattedMessage = message.replace(/### (\d+)\. \*\*(.*?)\*\*/g, '<h3>$1. $2</h3>') 
                                        .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')      
                                        .replace(/- (.*?)$/gm, '<li>$1</li>')                  
                                        .replace(/<\/li>\n<li>/g, '</li><li>')                  
                                        .replace(/<li>(.*?)<\/li>/g, '<ul><li>$1</li></ul>')   
                                        .replace(/<\/ul>\n<ul>/g, '')                         
                                        .replace(/<\/ul>\n<h3>/g, '</ul><br><h3>');           

        messageElement.innerHTML = `
        <div class="flex justify-start my-0 text-16 w-full flex-row gap-x-4">
            <svg class="flex flex-none" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="url(#a_bg_svg)"/><path d="M19.815 30.286a8.571 8.571 0 0 1 0-17.143v17.142Z" fill="#FDBD9A"/><path d="M21.243 10a7.142 7.142 0 1 1 0 14.286V10Z" fill="#F2F2F2"/><defs><linearGradient id="a_bg_svg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#FE7165"/><stop offset="1" stop-color="#FF8D78"/></linearGradient></defs></svg>
            <div class="bg-transparent text-black rounded-24 px-2 pb-4 text-16 text-darkblue leading-160 flex flex-col gap-y-2 w-full">
                ${formattedMessage}
            </div>
        </div>`;  

        removeHighlightRecentMsg();
    } else {
        messageElement.innerHTML = `
        <div class="flex justify-end my-0 text-16 w-full">
            <div class="bg-white rounded-user user-new-question px-5 py-4 max-w-550 text-16 text-darkblue leading-140">
                ${message}
            </div>
        </div>`;  
    }

    chatMessages.appendChild(messageElement);
    chatMessages.scrollTop = chatMessages.scrollHeight;
};


export const initThread = (payslipContext) => {
    const chatInput = document.getElementById('chat-input');
    const chatSubmit = document.getElementById('chat-submit');
    let conversationId = getOrCreateConversationId();

    // Initialize chat with suggested messages
    const initializeChat = () => {
        displaySuggestedMessages();
    };


    const sendMessage = async (message, useEnterEndpoint = false) => {
        // Track first user interaction
        trackingEvent();
        
        toggleLoadingAnimation(true);

        addMessageToChat(message, 'user');
        chatInput.value = '';

        const endpoint = useEnterEndpoint ? POLICY_BUILDER_AGENT_URL_ENTER : POLICY_BUILDER_AGENT_URL;

        try {
            // Use new Policy Builder Agent endpoint
            console.log('Sending request to:', endpoint);
            console.log('Request body:', { id: conversationId, message: message });
            
            const response = await fetch(endpoint, {
                method: 'POST',
                
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${POLICY_BUILDER_JWT_SECRET}`,
                    'Accept': 'application/json'
                },
                body: JSON.stringify({ 
                    id: conversationId,
                    message: message 
                })
            });

            console.log('Response status:', response.status);
            console.log('Response headers:', response.headers);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                throw new Error(`Failed to send message: ${response.status} - ${errorText}`);
            }

            const data = await response.json();
            toggleLoadingAnimation(false);

            console.log('Response data:', data);

            // Handle response from new agent - data is an array
            if (Array.isArray(data) && data.length > 0) {
                const responseItem = data[0];
                
                if (responseItem.attachments) {
                    // Check if attachments.files is an array and get the files
                    let attachmentsToProcess = responseItem.attachments;
                    
                    if (responseItem.attachments.files && Array.isArray(responseItem.attachments.files)) {
                        attachmentsToProcess = responseItem.attachments.files.reverse();
                    }
                    
                    // Only process attachments if files array is not empty
                    if (attachmentsToProcess.length > 0) {
                        // Check if attachments contain fileId
                        const hasFileId = attachmentsToProcess.some(attachment => attachment.fileId);
                        
                        if (hasFileId) {
                            // Show reply message with download button(s) integrated
                            if (responseItem.reply) {
                                if (attachmentsToProcess.length === 1) {
                                    // Single file - use original function
                                    const firstFileId = attachmentsToProcess.find(attachment => attachment.fileId)?.fileId;
                                    addMessageWithDownload(responseItem.reply, firstFileId);
                                } else {
                                    // Multiple files - create multiple numbered buttons
                                    const messageElement = document.createElement('div');
                                    messageElement.classList.add('flex', 'flex-col', 'w-full');

                                    const formattedMessage = responseItem.reply.replace(/### (\d+)\. \*\*(.*?)\*\*/g, '<h3>$1. $2</h3>') 
                                                                                .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')      
                                                                                .replace(/- (.*?)$/gm, '<li>$1</li>')                  
                                                                                .replace(/<\/li>\n<li>/g, '</li><li>')                  
                                                                                .replace(/<li>(.*?)<\/li>/g, '<ul><li>$1</li></ul>')   
                                                                                .replace(/<\/ul>\n<ul>/g, '')                         
                                                                                .replace(/<\/ul>\n<h3>/g, '</ul><br><h3>');           

                                    // Generate download buttons for each file
                                    const downloadButtons = attachmentsToProcess.map((file, index) => {
                                        const buttonLabel = index === 0 ? 'Política personalizada' : 'Política-modelo Coverflex';
                                        return `<button type="button" class="bg-download" onclick="downloadFile('${file.fileId}')">
                                            ${buttonLabel}
                                        </button>`;
                                    }).join('');

                                    messageElement.innerHTML = `
                                    <div class="flex justify-start my-0 text-16 w-full flex-row gap-x-4">
                                        <svg class="flex flex-none" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="url(#a_bg_svg)"/><path d="M19.815 30.286a8.571 8.571 0 0 1 0-17.143v17.142Z" fill="#FDBD9A"/><path d="M21.243 10a7.142 7.142 0 1 1 0 14.286V10Z" fill="#F2F2F2"/><defs><linearGradient id="a_bg_svg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#FE7165"/><stop offset="1" stop-color="#FF8D78"/></linearGradient></defs></svg>
                                        <div class="bg-transparent text-black rounded-24 px-2 pb-4 text-16 text-darkblue leading-160 flex flex-col gap-y-2 w-full">
                                            ${formattedMessage}
                                            ${downloadButtons}
                                        </div>
                                    </div>`;  

                                    removeHighlightRecentMsg();
                                    chatMessages.appendChild(messageElement);
                                    chatMessages.scrollTop = chatMessages.scrollHeight;
                                }
                            }
                        } else {
                            addMessageToChat(attachmentsToProcess);
                        }
                    } else if (responseItem.reply) {
                        // No files in attachments, but there's a reply - show just the message
                        addMessageToChat(responseItem.reply);
                    }
                } else if (responseItem.reply) {
                    addMessageToChat(responseItem.reply);
                } else {
                    addMessageToChat('Desculpa, não consegui processar a tua mensagem. Tenta novamente.');
                }
            } else if (data.attachments) {
                // Check if attachments.files is an array and get the files
                let attachmentsToProcess = data.attachments;
                
                if (data.attachments.files && Array.isArray(data.attachments.files)) {
                    attachmentsToProcess = data.attachments.files.reverse();
                }
                
                // Only process attachments if files array is not empty
                if (attachmentsToProcess.length > 0) {
                    // Check if attachments contain fileId
                    const hasFileId = attachmentsToProcess.some(attachment => attachment.fileId);
                    
                    if (hasFileId) {
                        // Show reply message with download button(s) integrated
                        if (data.reply) {
                            if (attachmentsToProcess.length === 1) {
                                // Single file - use original function
                                const firstFileId = attachmentsToProcess.find(attachment => attachment.fileId)?.fileId;
                                addMessageWithDownload(data.reply, firstFileId);
                            } else {
                                // Multiple files - create multiple numbered buttons
                                const messageElement = document.createElement('div');
                                messageElement.classList.add('flex', 'flex-col', 'w-full');

                                const formattedMessage = data.reply.replace(/### (\d+)\. \*\*(.*?)\*\*/g, '<h3>$1. $2</h3>') 
                                                                  .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')      
                                                                  .replace(/- (.*?)$/gm, '<li>$1</li>')                  
                                                                  .replace(/<\/li>\n<li>/g, '</li><li>')                  
                                                                  .replace(/<li>(.*?)<\/li>/g, '<ul><li>$1</li></ul>')   
                                                                  .replace(/<\/ul>\n<ul>/g, '')                         
                                                                  .replace(/<\/ul>\n<h3>/g, '</ul><br><h3>');           

                                // Generate download buttons for each file
                                const downloadButtons = attachmentsToProcess.map((file, index) => {
                                    const buttonLabel = index === 0 ? 'Política de Benefícios atual' : 'Política de Benefícios Coverflex';
                                    return `<button type="button" class="bg-download" onclick="downloadFile('${file.fileId}')">
                                        ${buttonLabel}
                                    </button>`;
                                }).join('');

                                messageElement.innerHTML = `
                                <div class="flex justify-start my-0 text-16 w-full flex-row gap-x-4">
                                    <svg class="flex flex-none" width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="20" cy="20" r="20" fill="url(#a_bg_svg)"/><path d="M19.815 30.286a8.571 8.571 0 0 1 0-17.143v17.142Z" fill="#FDBD9A"/><path d="M21.243 10a7.142 7.142 0 1 1 0 14.286V10Z" fill="#F2F2F2"/><defs><linearGradient id="a_bg_svg" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse"><stop stop-color="#FE7165"/><stop offset="1" stop-color="#FF8D78"/></linearGradient></defs></svg>
                                    <div class="bg-transparent text-black rounded-24 px-2 pb-4 text-16 text-darkblue leading-160 flex flex-col gap-y-2 w-full">
                                        ${formattedMessage}
                                        ${downloadButtons}
                                    </div>
                                </div>`;  

                                removeHighlightRecentMsg();
                                chatMessages.appendChild(messageElement);
                                chatMessages.scrollTop = chatMessages.scrollHeight;
                            }
                        }
                    } else {
                        addMessageToChat(attachmentsToProcess);
                    }
                } else if (data.reply) {
                    // No files in attachments, but there's a reply - show just the message
                    addMessageToChat(data.reply);
                }
            } else if (data.reply) {
                addMessageToChat(data.reply);
            } else if (data.message) {
                addMessageToChat(data.message);
            } else {
                addMessageToChat('Desculpa, não consegui processar a tua mensagem. Tenta novamente.');
            }

            // Handle follow-up questions if available
            const responseItem = Array.isArray(data) && data.length > 0 ? data[0] : data;
            if (responseItem && responseItem.followUpQuestions) {
                setTimeout(() => {
                    displayFollowUpQuestions(responseItem.followUpQuestions);
                }, 2000);
            }
        } catch (error) {
            console.error('Error sending message:', error);
            toggleLoadingAnimation(false);
            addMessageToChat('Desculpa, ocorreu um erro ao processar sua mensagem. Por favor, tente novamente.', 'bot');
        }
    };


    // Function to start a new conversation
    const startNewConversation = () => {
        clearConversationId();
        conversationId = getOrCreateConversationId();
        
        // Clear chat messages
        const chatMessages = document.getElementById('chat-messages');
        chatMessages.innerHTML = `
            <div class="text-center font-semibold w-full mx-auto pb-4">
                <p class="px-4 md:px-0 text-20 leading-140 block max-w-600 mx-auto">Nova conversa iniciada! Pergunta o que quiseres ao nosso assistente virtual</p>
            </div>
        `;
        
        // Show suggested messages for new conversation
        displaySuggestedMessages();
        
        console.log('New conversation started with ID:', conversationId);
    };

    // Add new conversation button (optional)
    const addNewConversationButton = () => {
        const chatHeader = document.getElementById('chat-header');
        if (chatHeader && !document.getElementById('new-conversation-btn')) {
            const newConversationBtn = document.createElement('button');
            newConversationBtn.id = 'new-conversation-btn';
            newConversationBtn.textContent = 'Nova Conversa';
            newConversationBtn.className = 'bg-white text-darkblue px-3 py-1 rounded text-sm hover:bg-gray-100 transition-colors';
            newConversationBtn.onclick = startNewConversation;
            chatHeader.appendChild(newConversationBtn);
        }
    };

    const displayFollowUpQuestions = (questions) => {
        if (!questions || questions.length === 0) return;

        const followUpContainer = document.createElement('div');
        followUpContainer.className = 'flex flex-wrap justify-end gap-2 mb-2';

        questions.forEach(question => {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'transition duration-300 ease-in-out shadow-custom bg-lighterpeppermint border border-darkblue rounded-12 text-darkblue font-semibold px-3 py:3 lg:px-5 lg:py-4 hover:shadow-full-peppermint hover:border-lighterpeppermint text-14';
            button.textContent = question;
            button.onclick = () => sendMessage(question);
            followUpContainer.appendChild(button);
        });

        chatMessages.appendChild(followUpContainer);
        chatMessages.scrollTop = chatMessages.scrollHeight;
    };

    // Display suggested messages on load
    const displaySuggestedMessages = () => {
        const suggestedQuestions = [
            "Quero criar uma política de benefícios",
            "O que é uma política de benefícios?"
        ];

        const suggestedContainer = document.createElement('div');
        suggestedContainer.className = 'flex flex-wrap justify-center gap-3 mb-4 mt-4';

        suggestedQuestions.forEach(question => {
            const questionButton = document.createElement('button');
            questionButton.type = 'button';
            questionButton.textContent = question;
            questionButton.className = 'firstQuestions bg-orange text-white px-6 py-3 rounded-full text-16 hover:bg-orange-600 transition-colors cursor-pointer font-medium';
            suggestedContainer.appendChild(questionButton);
        });

        chatMessages.appendChild(suggestedContainer);
        chatMessages.scrollTop = chatMessages.scrollHeight;
    };

    // Prevent form submission from causing page refresh
    const documentForm = document.getElementById('documentForm');
    if (documentForm) {
        documentForm.addEventListener('submit', (event) => {
            event.preventDefault();
            const message = chatInput.value.trim();
            if (message) {
                sendMessage(message);
            }
        });
    }
    
    // Ensure submit button doesn't cause page refresh
    chatSubmit.type = 'button';
    
    chatSubmit.addEventListener('click', (event) => {
        event.preventDefault();
        const message = chatInput.value.trim();
        if (message) {
            sendMessage(message);
        }
    });

    chatInput.addEventListener('keyup', (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
            const message = chatInput.value.trim();
            if (message) {
                sendMessage(message, true); // Use Enter endpoint
            }
        }
    });

    document.body.addEventListener('click', (event) => {
        if (event.target.classList.contains('firstQuestions')) {
            const message = event.target.textContent.trim();
            sendMessage(message);
        }
    });

    // Initialize chat with suggested messages
    initializeChat();
};
